import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment/moment';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.min.css'
import { FaCalendarAlt } from 'react-icons/fa';

const DateInput = (props) => {
    const {
        input,
        label,
        placeHolder,
        require,
        dateFormat = 'dd/MM/yyyy',
        halfRow = false,
        disabled,
        minDate,
        maxDate,
        meta: { touched, error },
    } = props

    return (
        <div className={`${halfRow ? 'w-1/2' : 'w-full'} px-3`}>
            <label className="block tracking-wide text-gray-800 font-bold text-sm  mb-2 text-left" >
                {label}
                {require ? <span className='ml-2 text-red-500 require'>*</span> : null}
                {touched && error ? <span className='ml-2 text-red-500 require'>{error}</span> : null}
            </label>
            <DatePicker
                style={{ backgroundColor: touched && error ? "#FFF0F0 !important" : "" }}
                selected={input.value}
                className={`text-base appearance-none outline-none focus:outline-none  block w-full  text-gray-8 border 
                border-[#FBC558] rounded text-gray-800 py-3 px-4  leading-tight ${touched && error ? "bg-[#FFF0F0]" : ""}`}
                dateFormat={dateFormat}
                minDate={minDate}
                maxDate={maxDate}
                disabled={disabled}
                placeholderText={placeHolder}
                onChange={date => {
                    input.onChange(date)
                }}
            />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(DateInput)